import React from 'react';
import { MDText } from 'i18n-react';

import type { IconComponentFunction } from '@motorway/mw-highway-code';
import { WarningIcon } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';

import { SectionState } from '../SectionState';

import LocalTexts from './SectionError.texts.json';

const LocalT = new MDText(LocalTexts);

interface SectionErrorProps {
	icon?: IconComponentFunction;
}

export const SectionError: React.FC<SectionErrorProps> = ({ icon }) => {
	return (
		<SectionState
			description={LocalT.translate('description')}
			icon={icon || WarningIcon}
			testId={cypressIds.containers.pageSectionErrorState}
			title={LocalT.translate('title')}
		/>
	);
};
